import { Observable } from "rxjs";
import { MatchDetail } from "@app/core/match/domain/model/match-detail";
import { Match } from "@app/core/match/domain/model/match";
import { MatchSearchCriteria } from "@app/core/match/domain/match-search-criteria";
import { PaginatedResponse } from "@app/core/shared/domain/paginated-response";
import { MatchPaymentInfo } from "@app/core/match/domain/model/match-payment-info";

/**
 * Repository used to get coach details.
 */
export abstract class CoachRepo {
  abstract getCoachPhoneNumber(token: string, matchid: string): Observable<string>;
}
